import React, { useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import useTendering from "../../../hooks/useTendering";
import Design from "./Design";
import Construction from "./Construction";
import QuotationTenderingContext from "./QuotationTenderingContext";
import _ from "lodash";

/**
 * Use for checking where to navigate to next
 */
const Check = () => {
  const { id } = useParams();
  const { getById } = useTendering();
  const navigate = useNavigate();
  const { setDetails } = useContext(QuotationTenderingContext);

  useEffect(() => {
    getById(id)
      .then((result) => {
        if (!result.active || result.deleted) {
          navigate("/404");
          return;
        }

        setDetails({ _id: result._id, category: result.category });

        if (result.category === 1) {
          navigate("design/details");
          return;
        }

        navigate("construction/details");
      })
      .catch((error) => {
        console.error(error);
        navigate("/404");
      });
  }, [id]);

  return `test ${id}`;
};

const Quotation = (props) => {
  const [step, setStep] = useState(0);
  const [details, setDetails] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (step === 0) return;
    if (!_.isEmpty(details)) return;

    navigate("./");
  }, [step, details]);

  const handleForward = () => {
    if (details.category === 1) {
      if (step === 1) {
        navigate("./design/payment-terms");
      }

      if (step === 2) {
        navigate("./design/summary");
      }

      return;
    }

    if (step === 1) {
      navigate("./construction/payment-terms");
    }

    if (step === 2) {
      navigate("./construction/summary");
    }
  };

  const handleBackward = () => {
    if (step === 1) {
      navigate(`/tenderings/${details._id}`);
      return;
    }

    if (details.category === 1) {
      if (step === 2) {
        navigate("./design/details");
      }

      if (step === 3) {
        navigate("./design/payment-terms");
      }

      return;
    }

    if (step === 2) {
      navigate("./construction/details");
    }

    if (step === 3) {
      navigate("./construction/payment-terms");
    }
  };

  const contextValues = useMemo(
    () => ({
      details,
      setDetails,
      step,
      setStep,
      goForward: handleForward,
      goBack: handleBackward,
    }),
    [step, details]
  );

  return (
    <QuotationTenderingContext.Provider value={contextValues}>
      <div className="tendering-quotation">
        <Routes>
          <Route path="" element={<Check />} />
          <Route path="design/*" element={<Design />} />
          <Route path="construction/*" element={<Construction />} />
        </Routes>
      </div>
    </QuotationTenderingContext.Provider>
  );
};

Quotation.propTypes = {};

export default Quotation;
